import React, { useContext, useState } from 'react';
import { AppContext } from '../main';
import { Link } from 'react-router-dom';

const StatBox = ({ iconClass, value, label, extraClass }) => (
    <div className={`d_wrap_sm-box d-lg-block d-none ${extraClass} zoomIn`}>
        <i className={`bg-gradient ${iconClass}`}></i>
        <h3>{value}</h3>
        <h6>{label}</h6>
    </div>
);

const Section = (props) => {
    const { handleEditItem } = props
    const {
        appState,
        setAppState,
    } = useContext(AppContext);



    const {
        editMode = false,
        bannerPointer = {
            subtitle: "Level Up Your Game",
            title: "Your victory begins with ultra performance",
            description: `Welcome to the ultimate gaming experience! Our game hosting 
                service is designed to take your gaming adventures to the next level. 
                With lightning-fast servers, unbeatable reliability, and 24/7 support, 
                we're here to ensure your gaming experience is seamless and stress-free. 
                Join us and let's embark on an epic gaming journey together. 
                Your victory begins here!`,
            buttonText: "Order Your Game Server Now",
            buttonLink: "/",
            stats: [
                { iconClass: "fa fa-users", value: "15425", label: "Happy Gamers", extraClass: "b1" },
                { iconClass: "fa-solid fa-rotate", value: "99.99%", label: "Uptime", extraClass: "b2" },
                { iconClass: "fa fa-thumbs-up", value: "15 Years", label: "Experience", extraClass: "b3" }
            ],
            image: {
                src: "./img/misc/server-2.webp",
                alt: "Game Server"
            }
        }
    } = appState



    return (
        <div className="container">

            <div className="row align-items-center gx-5">

                {/* Left Content */}
                <div className="col-lg-6">
                    <div className="subtitle fadeInUp mb-3">{bannerPointer.subtitle}</div>
                    <h2 className="wow fadeInUp">{bannerPointer.title}</h2>
                    <p className="wow fadeInUp">{bannerPointer.description}</p>
                    <div className="spacer-10"></div>
                    <Link className="btn-main" to={bannerPointer.buttonLink}
                        onClick={() => {
                            setAppState((existing) => {
                                return {
                                    ...existing,
                                    showServices: true,
                                };
                            });
                        }}
                    >{bannerPointer.buttonText}</Link>

                </div>

                {/* Right Image & Stats */}
                <div className="col-lg-6">
                    <div className="d_wrap">
                        <img
                            src={bannerPointer.image.src}
                            className="img-fluid fadeIn"
                            alt={bannerPointer.image.alt}
                        />

                        {/* Stats Boxes */}
                        {bannerPointer.stats.map((stat, index) => (
                            <StatBox key={index} {...stat} />
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Section;
